import { render } from "./ProductGrid.vue?vue&type=template&id=1ad25281&scoped=true"
import script from "./ProductGrid.vue?vue&type=script&lang=js"
export * from "./ProductGrid.vue?vue&type=script&lang=js"

import "./ProductGrid.vue?vue&type=style&index=0&id=1ad25281&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ad25281"]])

export default __exports__